export default function Privacy(){
  return (
    <div className="mx-auto max-w-3xl px-4 py-10 prose">
      <h1>Privacy</h1>
      <p>We log minimal data needed to deliver emails and detect abuse. See details in the policy page.</p>
    </div>
  )
}